var map = {
	"./custom/app/shared/auth-nav-menu/auth-nav-menu.component": [
		64235,
		"src_themes_custom_app_shared_auth-nav-menu_auth-nav-menu_component_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 51808;
module.exports = webpackAsyncContext;